import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { SigningDocumentCover, CoverItem } from 'src/components/Cover';
import { Grid } from '@material-ui/core';
import { Link } from './styles';
import { t } from 'i18next';
import { MandatesCoverWrapper } from 'src/components/Cover/styles';

interface Props extends RouteComponentProps<any> {
  canCreateMandate?: boolean;
}

const CoverSection = ({ canCreateMandate = false, match }: Props) => {
  return (
    <>
      <MandatesCoverWrapper>
        <SigningDocumentCover />
      </MandatesCoverWrapper>
      {canCreateMandate ? (
        <CoverItem
          container
          justifyContent="flex-end"
          style={{ marginTop: '-100px' }}
        >
          <Grid item xs={12} md="auto">
            <Link to={`${match.url}/New`} data-testid="new-mandate-btn">
              {t('MandateCreateButton')}
            </Link>
          </Grid>
        </CoverItem>
      ) : null}
    </>
  );
};

export default withRouter(CoverSection);
